import { useEffect } from 'react';
import type { AppProps } from 'next/app';
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import { initTheme } from '@/lib/theme';
import '../styles/globals.css';

export default function App({ Component, pageProps }: AppProps) {
  useEffect(() => {
    initTheme();
  }, []);

  return (
    <>
      <Nav />
      <Component {...pageProps} />
      <Footer />
    </>
  );
}
